import qs from "query-string";

/**
 * @param {Record<string, any>} object - parsed search params
 * @param {import("query-string").StringifyOptions} [options] - query.stringify options from query-string package
 */
export const paramStringify = (object, options = {}) =>
  qs.stringify(object, {
    skipEmptyString: true,
    skipNull: true,
    arrayFormat: "comma",
    ...options,
  });

/**
 *
 * @param {String} query - stringified parsed search
 * @param {import("query-string").ParseOptions} [options] - query.parse options from query-string package
 */
export const paramParsify = (query, options = {}) =>
  qs.parse(query, {
    parseBooleans: true,
    arrayFormat: "comma",
    ...options,
  });

/**
 *
 * @param {String} pathname - location.pathname
 * @param {String} stringifiedParams - queryParams from stringifiedParams result function
 */
export const generateUrlWithParams = (pathname, stringifiedParams) =>
  `${pathname}${stringifiedParams ? `?${stringifiedParams}` : ""}`;
